<template>
  <el-select
    v-model="locationModel"
    @change="locationChanged"
    autocomplete="new-password"
    :placeholder="$t('COMMON.LOCATIONS')"
    :filterable="true"
    :multiple="false"
    :disabled="disabled"
    remote
    :remote-method="getLocations"
    :loading="loading"
  >
  <el-option
      v-if="showAll"
      :value="null"
      :label="$t('COMMON.ALL_LOCATIONS')"
    >
    </el-option>
    <el-option v-if="allowNone" :value="null" :label="$t('COMMON.NONE')"></el-option>
    <el-option
      v-for="location in locations"
      :key="location.id"
      :value="location.id"
      :label="`${location.name}`"
    >
    </el-option>
  </el-select>
</template>

<script>
import { difference } from "lodash";
import { Option, Select } from "element-ui";

export default {
  name: "location-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    showAll: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
    location: {
      type: String,
      default: null,
      description: "Location id",
    },
    organization: {
      type: String,
      default: null,
      description: "Organization id",
    },
  },

  data() {
    return {
      locationModel: this.location,
      locations: {},
    };
  },

  setup() {},

  created() {
    this.getLocations(null, this.location);
  },

  methods: {
    async getLocations(query = null, id = null) {
      try {
        this.loading = true;
        let params = {
          sort: "name",
          filter: {
            ...(query ? { search: query } : {}),
            ...(id ? { id: id } : {}),
          },
          page: {
            number: 1,
            size: 10,
          },
        };

        if (this.organization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.organization,
            },
          };
        }
        await this.$store.dispatch("locations/list", params);
        const locationsArr = await this.$store.getters["locations/list"];
        this.locations = {};
        locationsArr.forEach((location) => {
          this.locations[location.id] = location;
        });
        if(this.organization){
          this.locationModel = Object.keys(this.locations)[0];
          this.locationChanged(this.locationModel);
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    locationChanged(locationId) {
      const location = Object.values(this.locations).find(
        (item) => item.id === locationId
      );
      this.$emit("locationChanged", locationId, location);
    },
  },

  watch: {
    location(location) {
      if (location) {
        this.locationModel = location;
        if (location !== this.locationModel) {
          this.getLocations(null, location);
        }
      } else {
        this.locationModel = null;
      }
    },
    organization(organization) {
      this.getLocations();
    },
  },
};
</script>
